export const DOCSIGN_PATH = 'roster.data.docsign';
export const ESIGN_BANNER_ARG = 'ESIGNATURE';
export const ERROR = 'ERROR';